import { render, staticRenderFns } from "./NuevoDiagnostico.vue?vue&type=template&id=7c8d1b7a&scoped=true"
import script from "./NuevoDiagnostico.vue?vue&type=script&lang=js"
export * from "./NuevoDiagnostico.vue?vue&type=script&lang=js"
import style0 from "./NuevoDiagnostico.vue?vue&type=style&index=0&id=7c8d1b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8d1b7a",
  null
  
)

export default component.exports